import { subscribeStyles } from "@insite/content-library/Widgets/Basic/Subscribe";
import { css } from "styled-components";

subscribeStyles.emailTextField = {
    cssOverrides: {
        formField: css`
            max-width: 300px;
            margin-right: 10px;
            > div[class^="FormInputWrapper"] {
                > input {
                    color: #000000;
                }
            }
        `,
    },
};
subscribeStyles.descriptionText = {
    css: css`
        margin-bottom: -1rem;
        > p {
            color: #fff;
            font-weight: 600;
        }
    `,
};
